import { checkReachGoalReady, getWhatId, sendMetric } from "@utils";

const { VITE_WHAT_ID } = import.meta.env;

export const sendCategoryMetric = (eventName, mainStore, categoryTitle = null) => {
    const variant = mainStore.getMainStore("abTestMetika") || "ris_promo";
    const siteId = getWhatId() || VITE_WHAT_ID;

    sendMetric(eventName, {
        params1: [variant],
        params2: null,
        params3: null,
        params4: null,
        params6: null,
        params7: null,
        params8: siteId,
        params9: categoryTitle,
    });

    const clickHouseEvent = {
        event: eventName,
        siteId,
        session_uuid: localStorage.getItem("_r_p_s"),
        widget_code: mainStore.getMainStore("codeTypeMetrika") || "",
        ml_traffic_mode: mainStore.getMainStore("codeWdm") || "",
        ml_model_code: mainStore.getMainStore("codeWdMc") || "",
        ...(categoryTitle ? { additional_property: { category: categoryTitle } } : {}),
    };
    const trackerReady = typeof window.risMetrika?.reachgoal_ch === "function" ? Promise.resolve() : checkReachGoalReady();

    return trackerReady.then(() => window.risMetrika.reachgoal_ch(clickHouseEvent)).catch((error) => console.error("Не удалось отправить метрику в ClickHouse:", error));
};
